import React, { memo } from 'react';

import { TableCell, TableHead, TableRow } from '@mui/material';

import { checklistItemsTableColumns } from './ChecklistItemsTable.constants';

const ChecklistItemsTableHead = () => (
  <TableHead>
    <TableRow className="h-64 uppercase">
      {checklistItemsTableColumns.map(({ align, id, label }) => (
        <TableCell align={align} key={id}>
          {label}
        </TableCell>
      ))}
    </TableRow>
  </TableHead>
);

export default memo(ChecklistItemsTableHead);
